import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { MODULES_BY_KEY, ROLE_ACCESS } from "@/config/modules";
import { Home } from "lucide-react";

const GROUPS = [
  { label: "Masters", keys: ["employee-master", "asset-register", "site-master"] },
  { label: "Field Operations", keys: ["fleetcare", "site-ops", "transport-log", "service-tracker"] },
  { label: "Business", keys: ["dataflow", "vendor-master", "payment-desk", "quote-master", "procure-flow", "daily-log-check"] },
  { label: "Configurations", keys: ["bank-master", "service-types", "service-grades", "service-part-codes"] },
];

export default function Sidebar({ open = false, onClose }) {
  const { user } = useAuth();
  const allowed = ROLE_ACCESS[user?.role] || [];

  const linkClass = ({ isActive }) =>
    `flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
      isActive ? "bg-amber-600 text-white" : "text-slate-300 hover:bg-white/5 hover:text-white"
    }`;

  return (
    <aside
      className={`w-64 shrink-0 bg-[#090D16] text-slate-300 flex flex-col fixed inset-y-0 left-0 z-50 transition-transform duration-200 ease-in-out ${
        open ? "translate-x-0" : "-translate-x-full"
      } md:static md:z-auto md:translate-x-0`}
      data-testid="app-sidebar"
    >
      <div className="px-5 py-6 border-b border-white/10">
        <p className="text-white font-bold text-lg tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
          S.D. Infratech
        </p>
        <p className="text-xs text-amber-500 font-mono uppercase tracking-widest mt-0.5">Unified ERP</p>
      </div>

      <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-6">
        {allowed.includes("dashboard") && (
          <NavLink to="/" end data-testid="sidebar-nav-dashboard" className={linkClass} onClick={onClose}>
            <Home className="h-4 w-4" /> Dashboard
          </NavLink>
        )}

        {GROUPS.map((group) => {
          const items = group.keys.filter((k) => allowed.includes(k));
          if (items.length === 0) return null;
          return (
            <div key={group.label}>
              <p className="px-3 text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-2">{group.label}</p>
              <div className="space-y-1">
                {items.map((key) => {
                  const mod = MODULES_BY_KEY[key];
                  const Icon = mod.icon;
                  return (
                    <NavLink key={key} to={mod.path} data-testid={`sidebar-nav-${key}`} className={linkClass} onClick={onClose}>
                      <Icon className="h-4 w-4" /> {mod.title}
                    </NavLink>
                  );
                })}
              </div>
            </div>
          );
        })}
      </nav>
    </aside>
  );
}
